import { ReduxDispatch } from "models/ReduxProps";
import BaseHeaderOptionModel from "stores/shared/models/BaseHeaderOptionModel";
import ActionUtility from "utilities/ActionUtility";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import CercaHeaderEffect, { CercaHeaderRequest } from "./CercaHeaderEffect";
import SearchModel from "./models/SearchModel";

type ActionUnion = undefined | HttpErrorResponseModel | SearchModel | BaseHeaderOptionModel;

export default class CercaHeaderAction {
    public static readonly REQUEST_HEADER_SEARCH: string = "CercaHeaderction.REQUEST_HEADER_SEARCH";
    public static readonly REQUEST_HEADER_SEARCH_FINISHED: string = "CercaHeaderction.REQUEST_HEADER_SEARCH_FINISHED";

    public static readonly REQUEST_HEADER_SET_FORM_VALUE: string = "CercaHeaderction.REQUEST_HEADER_SET_FORM_VALUE";

    public static search(request: CercaHeaderRequest): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<SearchModel>(
                dispatch,
                CercaHeaderAction.REQUEST_HEADER_SEARCH,
                CercaHeaderEffect.search,
                request
            );
        };
    }

    public static setForm(form: BaseHeaderOptionModel): any {
        return ActionUtility.createAction(CercaHeaderAction.REQUEST_HEADER_SET_FORM_VALUE, form);
    }
}
